import { DoctorInfo, UserEyeExam } from '@interfaces/myAppointmentInterfaces';
import * as actionTypes from './actionTypes';

import {
    IMySavedPrescriptionItem,
    IContactLensDetails,
    IDoctorList
} from '@interfaces/myAppointmentInterfaces';

//EYE EXAMS
export const getUserEyeExamsPending = () => {
    return {
        type: actionTypes.GET_USER_EYE_EXAMS_PENDING,
    };
};

export const getUserEyeExamsSuccess = (userEyeExams: UserEyeExam[]) => {
    return {
        type: actionTypes.GET_USER_EYE_EXAMS_SUCCESS,
        userEyeExams: userEyeExams,
    };
};

export const getUserEyeExamsError = () => {
    return {
        type: actionTypes.GET_USER_EYE_EXAMS_ERROR,
    };
};

export const getDoctorInfoPending = () => {
    return {
        type: actionTypes.GET_DOCTOR_INFO_PENDING,
    };
};

export const getDoctorInfoSuccess = (doctor: DoctorInfo) => {
    return {
        type: actionTypes.GET_DOCTOR_INFO_SUCCESS,
        doctor: doctor,
    };
};

export const getDoctorInfoError = () => {
    return {
        type: actionTypes.GET_DOCTOR_INFO_ERROR,
    };
};

export const deleteEyeExamPending = () => {
    return {
        type: actionTypes.DELETE_EYE_EXAM_PENDING,
    };
};

export const deleteEyeExamSuccess = () => {
    return {
        type: actionTypes.DELETE_EYE_EXAM_SUCCESS,
    };
};

export const deleteEyeExamError = () => {
    return {
        type: actionTypes.DELETE_EYE_EXAM_ERROR,
    };
};

export const syncMyEyeExamsPending = () => {
    return {
        type: actionTypes.SYNC_MY_EYE_EXAMS_PENDING,
    };
};

export const syncMyEyeExamsSuccess = () => {
    return {
        type: actionTypes.SYNC_MY_EYE_EXAMS_SUCCESS,
    };
};

export const syncMyEyeExamsError = () => {
    return {
        type: actionTypes.SYNC_MY_EYE_EXAMS_ERROR,
    };
};

//IN-STORE SERVICES

export const getAccessTokenPending = () => {
    return {
        type: actionTypes.GET_ACCESS_TOKEN_PENDING,
    };
};

export const getAccessTokenSuccess = (accessToken: string) => {
    return {
        type: actionTypes.GET_ACCESS_TOKEN_SUCCESS,
        accessToken: accessToken,
    };
};

export const getAccessTokenError = () => {
    return {
        type: actionTypes.GET_ACCESS_TOKEN_ERROR,
    };
};

export const addToCartPending = () => {
    return {
        type: actionTypes.ADD_TO_CART_PENDING,
    };
};

export const addToCartSuccess = () => {
    return {
        type: actionTypes.ADD_TO_CART_SUCCESS,
    };
};

export const addToCartError = () => {
    return {
        type: actionTypes.ADD_TO_CART_ERROR,
    };
};

export const removeMySavedPrescriptionPending = () => {
    return {
        type: actionTypes.REMOVE_PRESCRIPTION_PENDING,
    };
};

export const removeMySavedPrescriptionSuccess = () => {
    return {
        type: actionTypes.REMOVE_PRESCRIPTION_SUCCESS,
    };
};

export const removeMySavedPrescriptionError = () => {
    return {
        type: actionTypes.REMOVE_PRESCRIPTION_ERROR,
    };
};

export const getMySavedPrescriptionsPending = () => {
    return {
        type: actionTypes.GET_MY_SAVED_PRESCRIPTIONS_PENDING,
    };
};

export const getMySavedPrescriptionsSuccess = (
    mySavedPrescriptions: IMySavedPrescriptionItem[]
) => {
    return {
        type: actionTypes.GET_MY_SAVED_PRESCRIPTIONS_SUCCESS,
        mySavedPrescriptions: mySavedPrescriptions,
    };
};

export const getMySavedPrescriptionsError = () => {
    return {
        type: actionTypes.GET_MY_SAVED_PRESCRIPTIONS_ERROR,
    };
};

export const setJustUpdateId = (justUpdateId: string) => {
    return {
        justUpdateId: justUpdateId,
        type: actionTypes.JUST_UPDATE_ID,
    };
};

//CL DETAILS

export const getClDetailsRightPending = () => {
    return {
        type: actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_PENDING,
    };
};

export const getClDetailsRightSuccess = (clDetailRight: IContactLensDetails) => {
    return {
        clDetailRight: clDetailRight,
        type: actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_SUCCESS,
    };
};

export const getClDetailsRightError = () => {
    return {
        type: actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_ERROR,
    };
};

export const getClDetailsLeftPending = () => {
    return {
        type: actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_PENDING,
    };
};

export const getClDetailsLeftSuccess = (clDetailLeft: IContactLensDetails) => {
    return {
        clDetailLeft: clDetailLeft,
        type: actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_SUCCESS,
    };
};

export const getClDetailsLeftError = () => {
    return {
        type: actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_ERROR,
    };
};

export const getHowToReadEspotClSuccess = (espot: string) => {
    return {
        howToReadEspotCl: espot,
        type: actionTypes.GET_HOW_TO_READ_ESPOT_CL_SUCCESS,
    };
};

export const getHowToReadEspotClError = () => {
    return {
        type: actionTypes.GET_HOW_TO_READ_ESPOT_CL_ERROR,
    };
};

export const getHowToReadEspotClPending = () => {
    return {
        type: actionTypes.GET_HOW_TO_READ_ESPOT_CL_PENDING,
    };
};

export const setOpenModalAddDoctor = (openModalAddDoctor: boolean) => {
    return {
        openModalAddDoctor: openModalAddDoctor,
        type: actionTypes.SET_OPEN_MODAL_ADD_DOCTOR,
    };
};

export const getDoctorSuccess = (doctorList: IDoctorList) => {
    return {
        doctorList: doctorList,
        type: actionTypes.GET_DOCTOR_SUCCESS,
    };
};

export const getDoctorError = () => {
    return {
        type: actionTypes.GET_DOCTOR_ERROR,
    };
};

export const getDoctorPending = () => {
    return {
        type: actionTypes.GET_DOCTOR_PENDING,
    };
};

export const getPDEspotSuccess = (espot: string) => {
    return {
        pdEspot: espot,
        type: actionTypes.GET_PD_ESPOT_SUCCESS,
    };
};

export const getPDEspotError = () => {
    return {
        type: actionTypes.GET_PD_ESPOT_ERROR,
    };
};

export const getPDEspotPending = () => {
    return {
        type: actionTypes.GET_PD_ESPOT_PENDING,
    };
};

export const getHowToReadEspotSuccess = (espot: string) => {
    return {
        howToReadEspot: espot,
        type: actionTypes.GET_HOW_TO_READ_ESPOT_SUCCESS,
    };
};

export const getHowToReadEspotError = () => {
    return {
        type: actionTypes.GET_HOW_TO_READ_ESPOT_ERROR,
    };
};

export const getHowToReadEspotPending = () => {
    return {
        type: actionTypes.GET_HOW_TO_READ_ESPOT_PENDING,
    };
};